import { useEffect } from 'react';

export interface RecentItem { title: string; link: string; type: string }
const KEY = 'stoplord-recent';

export function readRecent(): RecentItem[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as RecentItem[];
  } catch {
    return [];
  }
}

/** Remember a viewed record for the command palette's "Recently viewed" list (per browser only). */
export function useTrackRecent(item: RecentItem | null) {
  useEffect(() => {
    if (!item) return;
    try {
      const list = [item, ...readRecent().filter((r) => r.link !== item.link)].slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch {
      /* storage unavailable */
    }
  }, [item?.link, item?.title]); // eslint-disable-line react-hooks/exhaustive-deps
}
